var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.src)?_c('vx-no-info-dash'):_c('b-img',{style:(_vm.style),attrs:{"fluid":"","rounded":"","alt":"img","src":_vm.src}})}
var staticRenderFns = []

export { render, staticRenderFns }